import { Button, Row, notification } from "antd";
import React from "react";
import { useFormContext } from "react-hook-form";
import { useQueryClient } from "react-query";
import { useMutation } from "@apollo/client/react";

import { SingleOrderActionsWrapper } from "./TaskDetailsActions.styled";
import { useMode } from "../../organisms";
import { UPDATE_TASK, GET_TASKS } from "../../../graphql/tasks";
import { queryStringToObject } from "../../organisms/filters/Filter.utils";

const SYNTHETIC_FIELD_TYPES = new Set(['redirect', 'form-modal', 'comments']);
const SYNTHETIC_UUIDS = new Set(['created_by', 'linked_to_item']);
const TOP_LEVEL_UUIDS = new Set(['name', 'priority', 'status', 'assigned']);

function buildUpdateTaskInput(
  formData: Record<string, any>,
  controls: any[] | undefined,
): Record<string, any> {
  const input: Record<string, any> = {};
  const content: Record<string, any> = {};

  for (const control of controls || []) {
    const uuid = control?.uuid;
    const fieldType = control?.field_type;
    const value = formData[uuid];

    if (!uuid || value === undefined) continue;

    if (TOP_LEVEL_UUIDS.has(uuid)) {
      input[uuid] = value;
      continue;
    }

    if (SYNTHETIC_FIELD_TYPES.has(fieldType) || SYNTHETIC_UUIDS.has(uuid)) {
      continue;
    }

    content[uuid] = value;
  }

  if (Object.keys(content).length > 0) {
    input.content = content;
  }

  return input;
}

export const TaskDetailsActions: React.FC = () => {
  const { mode, setMode } = useMode();
  const queryClient = useQueryClient();
  const methods = useFormContext();
  const paramas = queryStringToObject(location.search);

  const [updateTaskMutate, { loading: isLoading }] = useMutation(UPDATE_TASK, {
    refetchQueries: ["Tasks"],
    onCompleted: () => {
      queryClient.invalidateQueries("/tasks");
      queryClient.invalidateQueries(["/task-details", paramas?.id]);
      notification.success({
        message: "Zapisano zmiany",
        style: {
          background: "#52c41a30",
        },
      });
      setMode("read");
    },
    onError: () => {
      notification.error({
        message: "Błąd zapisu danych",
        style: {
          background: "#ff4d4f30",
        },
      });
    },
  });

  const submit = () => {
    methods.handleSubmit((data) => {
      const taskDetails = queryClient.getQueryData<any>([
        "/task-details",
        paramas?.id,
      ]);
      const controls = taskDetails?.content;
      const input = buildUpdateTaskInput(data, controls);

      updateTaskMutate({
        variables: { id: Number(paramas?.id), input },
      });
    }, console.error)();
  };

  if (mode === "edit") {
    return (
      <Row
        justify="end"
        style={{
          height: "32px",
        }}
      >
        <SingleOrderActionsWrapper>
          <Button
            type="primary"
            disabled={isLoading}
            danger
            onClick={() => setMode("read")}
          >
            Anuluj
          </Button>
          <Button type="primary" onClick={submit} loading={isLoading}>
            Zapisz
          </Button>
        </SingleOrderActionsWrapper>
      </Row>
    );
  }

  return null;
};
